import React from 'react';
import './navbar.css';

export default function Menu(props) {

    return (
        <div className='nav--command nav--items--card'>
            <ul className="text-end">
                <li className="nav-item me-4">
                    <a onClick={props.handleToggle} className="nav-link" href="#About" aria-current='page'>
                        <i className="bi bi-person link--icons"></i>
                        About
                    </a>
                </li>
                <li className="nav-item me-4">
                    <a onClick={props.handleToggle} className="nav-link" href="#Specializations">
                        <i className="bi bi-sliders link--icons"></i>
                        Specializations
                    </a>
                </li>
                <li className="nav-item me-4">
                    <a onClick={props.handleToggle} className="nav-link" href="#Projects">
                        <i className="bi bi-view-list link--icons"></i>
                        Projects
                    </a>
                </li>
                <li className="nav-item me-4">
                    <a onClick={props.handleToggle} className="nav-link" href="#Contact">
                        <i className="bi bi-envelope link--icons"></i>
                        Contact
                    </a>
                </li>
            </ul>
        </div>
    )
}